import BloomerHome from '../organisms/BloomerHome';
import { WithErrorBoundary } from '@bloomays-lib/ui.shared';

/**
 * Espace personnel du freelance (Bloomer) — route /dashboard.
 * Le dashboard des missions freelance de l'équipe interne vit désormais
 * sur /missions-freelance (cf. FreelanceMissionsDashboard).
 */
const Dashboard = () => {
  return <BloomerHome />;
};

export default WithErrorBoundary(Dashboard);
